import { SET_INFO } from '../constants/index'

export const setInfo = (key, value) => ({
  type: SET_INFO,
  key,
  value,
})



// WEBPACK FOOTER //
// ./src/actions/info.js